import React from 'react'

import { Editor, fromRedactor, toRedactor, parseFromString } from './SuperChargedRte/index'
import { htmlToJson } from './SuperChargedRte/utils/serialize/jsonHtmlTransformations';
import { debounce, cloneDeep } from 'lodash';

const isLeaf = (node) => typeof node === 'object' && node['text'];

export const handleLocalizeEntry = (requestProps, slateJson) => {
  const { uidToEntry } = requestProps || {};
  const inlineVoid = ['inline'];
  if (!uidToEntry) return;
  const value = cloneDeep(slateJson);
  function traverseJson(json) {
    if (Array.isArray(json) && json.length) {
      //fix children
      const newJson = [];
      json.forEach((block, idx) => {
        if (block['type'] === 'reference' && inlineVoid.includes(block?.attrs?.['display-type'])) {
          let lastEl = newJson.length && newJson[newJson.length - 1];
          if (idx < 1 || (lastEl && !isLeaf(lastEl))) {
            newJson.push({ text: '' });
          }
          newJson.push(block);
          if (idx === json.length - 1) {
            newJson.push({ text: '' });
          }
        } else {
          newJson.push(block);
        }
      })
      // iterate child blocks;
      json.length = 0;
      json.push.apply(json, newJson);
      json.forEach(traverseJson);
    }
    else if (typeof json === 'object') {
      if (json.text) return;
      if (json.type === 'reference' && json.attrs) {
        const entryUid = json.attrs['entry-uid'];
        if (uidToEntry[entryUid] && uidToEntry[entryUid]['locale']) {
          json.attrs['locale'] = uidToEntry[entryUid]['locale'];
        }
      }
      if (json.children)
        traverseJson(json.children);
    }
  }
  traverseJson(value);
  return value;
}

const RichTextEditor = (props: any) => {
  const {
    value = '',
    contentStack = false,
    toolbarMode = 'basic',
    onChange = null,
    onError = null,
    hideToolbarOnBlur = false,
    customToolbarComponents = {},
    csOnlyBreakline,
    csBreakLineOnEnter,
    editorType = 'html',
    allowExtraTags = {},
    customPasteOptions = {},
    requestProps,
    debounceValue = 0,
    customChooseFromAssetsModal,
    customEmbedAssetsModal,
    openAMV2UploadTarget,
    ...otherProps
  } = props
  
  const getJsonValue = (html) => {
    let redactorJson = htmlToJson(html, allowExtraTags, { isWrappingInlineElementsEnabled: otherProps?.isWrappingInlineElementsEnabled})
    const localizedJson = handleLocalizeEntry(requestProps, redactorJson);
    return localizedJson || redactorJson
  }

  const editorValue = editorType === 'json' ? value : getJsonValue(value);

  const handleChange = (receivedJson: any) => {
    if (typeof receivedJson === 'string') {
      return onChange(receivedJson);
    }
    if (onChange) {
      if (editorType === 'json') {
        onChange(receivedJson);
      } else {
        onChange(toRedactor(receivedJson[0]));
      }
    }
  }

  const debounceOnChange = debounce((json) => handleChange(json), debounceValue || 0);
  
  return (
    <div >
      <Editor
        requestProps={requestProps}
        contentStack={true}
        toolbarMode={toolbarMode}
        value={editorValue}
        hideToolbarOnBlur={hideToolbarOnBlur}
        customToolbarComponents={customToolbarComponents}
        csOnlyBreakline={csOnlyBreakline}
        csBreakLineOnEnter={csBreakLineOnEnter}
        allowExtraTags={allowExtraTags}
        customPasteOptions={customPasteOptions}
        customChooseFromAssetsModal={customChooseFromAssetsModal}
        customEmbedAssetsModal={customEmbedAssetsModal}
        openAMV2UploadTarget={openAMV2UploadTarget}
        onChange={debounceValue ? debounceOnChange : handleChange}
        onError={onError}
        {...otherProps}
      />
    </div>
  )
}

export default RichTextEditor
export {
  toRedactor,
  fromRedactor
}
export { handleRTEAssetSubmit } from '../../utils/rteAssetSubmit'